import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function agenteSaque(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@agenteSaque/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@agenteSaque/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@agenteSaque/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@agenteSaque/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@agenteSaque/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@agenteSaque/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}